import "core-js/modules/es6.function.name";
import _classCallCheck from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf.js";
import _inherits from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imagestyle/imagestylecommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import { isImage } from "../image/utils";
/**
 * The image style command. It is used to apply different image styles.
 *
 * @extends module:core/command~Command
 */

var ImageStyleCommand =
/*#__PURE__*/
function (_Command) {
  _inherits(ImageStyleCommand, _Command);

  /**
   * Creates an instance of the image style command. Each command instance is handling one style.
   *
   * @param {module:core/editor/editor~Editor} editor The editor instance.
   * @param {Array.<module:image/imagestyle/imagestyleediting~ImageStyleFormat>} styles The styles that this command supports.
   */
  function ImageStyleCommand(editor, styles) {
    var _this;

    _classCallCheck(this, ImageStyleCommand);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImageStyleCommand).call(this, editor));
    /**
     * The name of the default style, if it is present. If there is no default style, it defaults to `false`.
     *
     * @readonly
     * @type {Boolean|String}
     */

    _this.defaultStyle = false;
    /**
     * A style handled by this command.
     *
     * @readonly
     * @member {Array.<module:image/imagestyle/imagestyleediting~ImageStyleFormat>} #styles
     */

    _this.styles = styles.reduce(function (styles, style) {
      styles[style.name] = style;

      if (style.isDefault) {
        _this.defaultStyle = style.name;
      }

      return styles;
    }, {});
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ImageStyleCommand, [{
    key: "refresh",
    value: function refresh() {
      var element = this.editor.model.document.selection.getSelectedElement();
      this.isEnabled = isImage(element);

      if (!element) {
        this.value = false;
      } else if (element.hasAttribute('imageStyle')) {
        var attributeValue = element.getAttribute('imageStyle');
        this.value = this.styles[attributeValue] ? attributeValue : false;
      } else {
        this.value = this.defaultStyle;
      }
    }
    /**
     * Executes the command.
     *
     *		editor.execute( 'imageStyle', { value: 'side' } );
     *
     * @param {Object} options
     * @param {String} options.value The name of the style (based on the
     * {@link module:image/image~ImageConfig#styles `image.styles`} configuration option).
     * @fires execute
     */

  }, {
    key: "execute",
    value: function execute(options) {
      var _this2 = this;

      var styleName = options.value;
      var model = this.editor.model;
      var imageElement = model.document.selection.getSelectedElement();
      model.change(function (writer) {
        // Default style means that there is no `imageStyle` attribute in the model.
        // https://github.com/ckeditor/ckeditor5-image/issues/147
        if (_this2.styles[styleName].isDefault) {
          writer.removeAttribute('imageStyle', imageElement);
        } else {
          writer.setAttribute('imageStyle', styleName, imageElement);
        }
      });
    }
  }]);

  return ImageStyleCommand;
}(Command);

export { ImageStyleCommand as default };